import forOwn from 'mout/object/forOwn'

/**
 * Sets time remaining to zero on all subtests
 * @param {object} uA the userAssessment being modified
 * @returns {object} uA with time remaining set to zero for all subtests
 */
export default function zeroTimeRemaining(uA) {
  let zeroTimeDestructured = {...uA.destructuredSubtests}
  forOwn({...zeroTimeDestructured}, (val, key) => {
    zeroTimeDestructured[key].timeRemaining = 0
    zeroTimeDestructured[key].complete = true
  })
  return {
    ...uA,
    destructuredSubtests: zeroTimeDestructured,
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/zeroTimeRemaining.js